export default __webpack_public_path__ + "static/media/alphas-header.e882b189.jpeg";